<div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/']">Dashboard</span> 
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']" [queryParams]="query_params" *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager')">Lead</span>
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']" [queryParams]="{customer_status: lead_details.lead_status}" *ngIf="role=='designer'">Lead </span>
    <span *ngIf="lead_details" class="capitalize" style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> {{lead_details.lead_status | replaceChar}}</span>
    <span style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details && lead_details.user_reference"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark capitalize" style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details && lead_details.user_reference">{{lead_details.user_reference.name}}</span>
  </div>
</div>
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="row px-4">
  <app-shared-top-menu [lead_id]='lead_id' [lead_details]='lead_details' [lead_status]='lead_status' [basic_info_tab]='"active"'></app-shared-top-menu>
  <div class="col-12 bg-white my-3 pt-3 mt-lg-0 pt-lg-5 mb8">
    <app-sms-call></app-sms-call>
    <div class="row mb-lg-5">
      <div class="col-md-4">
        <div class="form-group" *ngIf="lead_details">
          <label for="exampleFormControlInput1" class="ss-form-label">Lead Name</label>
          <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.name}}" readonly>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group" *ngIf="lead_details">
          <label for="exampleFormControlInput1" class="ss-form-label">Project Name</label>
          <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.project_details.name}}" readonly>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group" *ngIf="lead_details">
          <label for="exampleFormControlInput1" class="ss-form-label">Email</label>
          <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.email}}" readonly>
        </div>
      </div>

      <div class="col-md-8" *ngIf="!(role=='designer')">
        <div class="form-group" *ngIf="lead_details">
          <label for="exampleFormControlInput1" class="ss-form-label">Contact</label>
          <div class="d-flex">
            <input type="email" class="ss-form-control" id="exampleFormControlInput1" value="{{lead_details.contact}}" readonly style="width: 22rem;"><input class="checkbox" name="checkbox" id="checkbox" type="checkbox" [checked]="contact_visibel == true" style="display: none;" /><label class="label1 ml-2" for="checkbox" (click) = "changeContactStatus();">label</label> <span class="pl-2 pt-1">Contact visible to designer</span>
          </div>
        </div>
      </div>

      <div class="col-md-4" *ngIf="role=='designer' && contact_visibel == true">
        <div class="form-group" *ngIf="lead_details">
          <label for="exampleFormControlInput1" class="ss-form-label">Contact</label>
          <div class="d-flex">
            <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.contact}}" readonly>
          </div>
        </div>
      </div>

      <div class="col-12">
          <div class="col-12 form-group pl-0" *ngIf="customerDetails">
            <div *ngFor="let user of customerDetails; let i = index; " [attr.data-index]="i">
              <div *ngIf="user.relation != 'Customer'">
                <span class="col-12 pl-0 font-weight-bold d-block">
                Alternate Number {{i+1}}
                </span>
                <div class="col-4 d-inline-block form-group pl-0">
                    <label class="ss-form-label">Name</label>
                    <input type="text" class="form-control ss-form-control" value="{{user.name}}" readonly>
                </div>
                <div class="col-4 d-inline-block form-group pl-0">
                    <label class="ss-form-label">Relation</label>
                    <input type="text" class="form-control ss-form-control" value="{{user.relation}}" readonly>
                </div>
                <div *ngIf="!(role=='designer')" class="col-4 d-inline-block form-group pl-0">
                    <label class="ss-form-label">Contact</label>
                    <input type="text" class="form-control ss-form-control" value="{{user.contact}}" readonly>
                </div>
              </div>
            </div>
          </div>
      </div>
      
      <div class="col-md-4">
        <br>
        <button class="btn btn-pink" data-toggle="modal" data-target="#basicDetailsModal">click to update</button>
      </div>
      <!-- <div class="col-md-4">
        <div class="form-group">
          <label for="exampleFormControlInput1" class="ss-form-label">City</label>
          <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.city}}" readonly>
        </div>
      </div> -->

    </div>
  </div>
</div>

<div class="modal fade" id="basicDetailsModal" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-sm mobModal" role="document" style="width: 55rem;">
    <form [formGroup]="basicDetailsForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5>Lost Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
          </button>
        </div>
        <div class="modal-body">

          <div class="col-md-12 mt-4">
            <label class="filterHeading">Lead Name<span class="text-danger">*</span> </label>
            <input type="text" class="form-control mb-2 filterHeading" placeholder="lead name" formControlName = "name">
          </div>
          <div class="col-md-12 mt-4">
            <label class="filterHeading">Email<span class="text-danger">*</span> </label>
             <input type="email" class="form-control mb-2 filterHeading" placeholder="lead email" formControlName = "email">
          </div>
          <div class="col-md-12 mt-4" *ngIf="!(role=='designer')">
            <label class="filterHeading">Contact<span class="text-danger">*</span></label>
            <input type="number" class="form-control mb-2 filterHeading" placeholder="lead contact" formControlName="contact" maxlength=10 minlength=10>
          </div>

        </div>
        <div class="modal-footer">
          <input type="button" id="lost-button" value="Update" class="btn btn-pink addCursor" (click) = "updateBasicInfo()" [disabled]="!basicDetailsForm.valid">
        </div>
      </div>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/lead/basic-info/basic-info.component.html